<template>
   <div class="container-fluid  bg-light-purple overview-integrations">
      <div class="content">
         <div class="row ">
            <div id="mainContainer" class="col-12 main-container">
               <div class="row">
                  <div class="col-12">
                     <h1 class="title pb-0">{{ overviewIntegrationsData.content[0].header }}</h1>
                     <p>{{ overviewIntegrationsData.content[0].longDescription }}</p>
                  </div>
                  <div class="col-12 mb-2">
                     <Gallery :gallery="galleryData" :gallery-type="galleryType" />
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import { mapState } from 'vuex';
import Gallery from '../../components/playground/IntegrationGallery';
import metaGenerator from '../../util/meta.js';

export default {
   name: 'IntegrationOverview',

   components: {
      Gallery,
   },

   data() {
      return {
         galleryType: 'slick',
         ...(process.browser && { mixpanelIntegrationsTracker: this.$tracker.Integrations }),
      };
   },

   computed: {
      ...mapState(['overviewIntegrationsData']),
      galleryData() {
         const tabData = [];
         const content = this.overviewIntegrationsData.content[0].body;
         const makeSlug = text => {
            const kebabCased = text.replace(/ /g, '-');
            return kebabCased.toLowerCase();
         };
         content.forEach(element => {
            const ob = {
               title: element.header,
               id: element.id,
               slug: makeSlug(element.header),
               items: [],
            };
            element.customBody.forEach(el => {
               ob.items.push({
                  title: el.header,
                  image: el.vectorSource.file.url,
                  onclick: el.url,
               });
            });

            tabData.push(ob);
         });
         return tabData;
      },
   },

   asyncData({ store }) {
      return Promise.all([store.dispatch('OVERVIEW_INTEGRATIONS_PAGE_DATA_FETCH')]);
   },

   mounted() {
      this.mixpanelIntegrationsTracker.visited();
   },

   metaInfo() {
      return metaGenerator(this.overviewIntegrationsData);
   },
};
</script>

<style lang="scss" scoped>
@import '../../util';
.overview-integrations {
   padding-bottom: 260px;
}
.gallery ::v-deep {
   .card-selector-wrapper {
      #myTab {
         margin-bottom: 0;
      }
   }
}

.content {
   padding: 30px 0;

   @include media-breakpoint-up(sm) {
      padding: 30px;
   }

   @include media-breakpoint-up(md) {
      padding: 50px 30px 30px 30px;
   }

   @include media-breakpoint-up(lg) {
      padding: 50px 30px 50px 30px;
   }
}
</style>
